import { Transition } from "@headlessui/react"
import { Form, Head } from "@inertiajs/react"

import HeadingSmall from "@/components/heading-small"
import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import AppLayout from "@/layouts/app-layout"
import { newTeamPath, teamPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Create Team", href: newTeamPath() },
]

export default function TeamsNew() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Create Team" />

      <div className="space-y-6 px-4 py-6">
        <HeadingSmall
          title="Create team"
          description="Create a new team and switch into it"
        />

        <Form
          method="post"
          action={teamPath()}
          options={{ preserveScroll: true }}
          className="space-y-6"
        >
          {({ errors, processing, recentlySuccessful }) => (
            <>
              <div className="grid gap-2">
                <Label htmlFor="name">Name</Label>

                <Input
                  id="name"
                  name="name"
                  className="mt-1 block w-full"
                  required
                  placeholder="Team name"
                />

                <InputError className="mt-2" messages={errors.name} />
              </div>

              <div className="flex items-center gap-4">
                <Button disabled={processing}>Create Team</Button>

                <Transition
                  show={recentlySuccessful}
                  enter="transition ease-in-out"
                  enterFrom="opacity-0"
                  leave="transition ease-in-out"
                  leaveTo="opacity-0"
                >
                  <p className="text-sm text-neutral-600">Created</p>
                </Transition>
              </div>
            </>
          )}
        </Form>
      </div>
    </AppLayout>
  )
}
